import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Service worker registration (and all update-detection logic) now lives in
// src/components/PWAUpdatePrompt.tsx so it can drive the in-app update banner
// and share the registration handle with the React tree.

createRoot(document.getElementById("root")!).render(<App />);
